<template>
  <div class="classifyEdit-component" :style="height">
    <div class="classifyEdit-container" ref="addBooksComponent">
      <div class="global_popup_header">
        {{ title }}<i @click="$store.commit('windowHandle')"></i>
      </div>
      <el-form
        :model="form"
        ref="ruleForm"
        :rules="rules"
        label-position="top"
        @submit.native.prevent
      >
        <div class="global_popup_body">
          <div class="edit-opts">
            <p class="item">{{ $t("content.books.release") }}</p>
            <el-select
              v-model="bookValue"
              :placeholder="$t('placeholder.select')"
            >
              <el-option
                v-for="item in books"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="refreshBooksList-tips">
            (同步京东书单，将替换原自定义书单)
          </div>
        </div>
      </el-form>
      <div class="global_popup_footer">
        <button @click="submitForm('ruleForm')">
          {{ $t("commonMsg.confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    bookInfo: Object,
    channel: Object
  },
  computed: {
    rules() {
      const rules = {
        name: [
          { required: true, message: this.$t("verify.name"), trigger: "blur" }
        ]
      };
      return rules;
    }
  },
  data() {
    return {
      height: "",
      form: {
        name: "", //书单名字,
        device_show: 2
      },
      lang: "", //语言
      orgId: "",
      channelId: "阅读器书城默认",
      total: [],
      books: [
        {
          cid: 11,
          label: "阅读器书城默认",
          value: 11
        },
        {
          cid: 12,
          label: "阅读器书城会员",
          value: 12
        },
        {
          cid: 13,
          label: "阅读器书城特价",
          value: 13
        },
        {
          cid: 14,
          label: "阅读器书城新书",
          value: 14
        }
      ],
      bookValue: 11
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs.ruleForm.validate(async valid => {
        if (!this.channelId) {
          this.elMsg(this.$t("alertMsg.releaseChannel"), "error");
          return;
        }
        let formDate = {
          libraryId: this.channelId,
          cid: this.bookValue
        };
        this.$emit("refreshModules", formDate);
        this.$store.commit("windowHandle");
      });
    },
    httpRequest() {}
  },
  mounted() {
    if (
      this.title !== this.$t("alertMsg.refreshGroup") &&
      Object.keys(this.bookInfo).length
    ) {
      this.form = Object.assign(this.form, this.bookInfo);
      this.channelId = this.form.parent_id;
    } else {
      this.channelId = this.channel.id;
    }
    this.height = `height: ${this.$refs.addBooksComponent.clientHeight}px`;
  }
};
</script>

<style lang="scss">
.classifyEdit-component {
  @include globalPopup(450px, 380px);
  .classifyEdit-container {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    .edit-opts {
      display: flex;
      margin-bottom: 20px;
      > .el-input {
        flex: 1;
      }
      > .item {
        width: 100px;
        line-height: 30px;
      }
      > p {
        margin-right: 20px;
      }
      > p.items {
        margin-right: 0;
      }
      .edit-cover {
        position: relative;
        img {
          width: 120px;
          height: 166px;
        }
        .edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.5);
            .edit-upload-btn {
              display: block;
            }
          }
          .edit-upload-btn {
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .refreshBooksList-tips {
      text-align: center;
      color: #f56c6c;
      margin-bottom: 20px;
    }
  }
}

.itemIcom:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
